function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
//Material imports
import Typography from "@mui/material/Typography";
import withStyles from "@mui/styles/withStyles";
//Limitless imports
import { log as pilog } from "@limitless/common/utils";
import { validateMessageId } from "../..";
class RemoteContent extends PureComponent {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "log", pilog.getLogger("RemoteContent"));
    // this method hijacks all click events inside our remote content
    // it is to handle anchor links and absolute URLs
    _defineProperty(this, "handleAnchorClick", event => {
      this.log.debug("Click Detected ", event.target.href);
      let href = event.target.href;
      event.preventDefault();
      if (!href) {
        //check to see if the parent is a a tag
        href = event.target.parentElement.getAttribute("href");
      }
      if (href) {
        this.log.debug(`Link detected ${event.target.href}`);
        //check to see if this is a special message id link
        if (href.indexOf("messageId") === -1) {
          try {
            const elementName = `${event.target.href}`.split("#")[1];
            if (elementName && !this.props.allowNewWindow) {
              const formattedElementName = elementName.replace(new RegExp("%20", "g"), " ");
              this.log.debug(`Element Name ${formattedElementName}`);
              const domElement = document.getElementsByName(formattedElementName)[0];
              if (domElement) {
                domElement.scrollIntoView();
              } else {
                this.log.info(`Unable to find anchor for ${href}`);
              }
            } else {
              //if we clicked a link that is a URL, open a new tab
              window.open(href, "_blank");
            }
          } catch (error) {
            this.log.error("Error occured while attempting to click a link in remote html ", error);
          }
        } else {
          try {
            const messageLink = JSON.parse(decodeURI(href.substr(href.lastIndexOf("/") + 1, href.length)));
            if (process.env.REACT_APP_NAME === "CrowdManager") {
              window.open(`#/question-management/find/${messageLink.messageId}`, "_self");
            } else {
              validateMessageId(messageLink.messageId, this.props.onMessageLinkClick);
            }
          } catch (error) {
            this.log.error("Error occured while attempting to click a message id in remote html ", error);
          }
        }
      }
    });
  }
  sanitizeHtml(html) {
    if (!html) {
      return "";
    }

    // Remove <script> blocks
    html = html.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "");

    // Remove inline event handlers
    html = html.replace(/\son\w+\s*=\s*"[^"]*"/gi, "");
    html = html.replace(/\son\w+\s*=\s*'[^']*'/gi, "");
    html = html.replace(/\son\w+\s*=\s*[^\s>]+/gi, "");

    // Disallowed tags
    const disallowedTags = ["iframe", "object", "embed", "form", "link", "style", "meta", "script"];
    disallowedTags.forEach(tag => {
      const tagPattern = new RegExp(`<${tag}[^>]*>[\\s\\S]*?<\\/${tag}>`, "gi");
      html = html.replace(tagPattern, "");
      const selfClosingPattern = new RegExp(`<${tag}[^>]*/>`, "gi");
      html = html.replace(selfClosingPattern, "");
    });
    html = html.replace(/href="({.*})"/g, (match, p1) => {
      const encoded = p1.replace(/"/g, "&quot;");
      return `href="${encoded}"`;
    });
    return html;
  }
  decodeHtmlEntities(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }
  isMalicious(original, sanitized) {
    // If sanitized removed <script>, <iframe>, on* handlers → it's malicious
    if (/<script|on\w+=|<iframe|<object|<embed|<style|<link|<form/i.test(original)) {
      return true;
    }

    // Ignore harmless encoding differences (&quot; vs ")
    const normalize = str => str.replace(/&quot;/g, '"');
    return normalize(sanitized) !== normalize(original);
  }
  render() {
    const {
      content,
      id,
      classes,
      wrapWhiteSpace,
      color,
      wordBreak
    } = this.props;
    const decodedContent = this.decodeHtmlEntities(content);
    const sanitizedContent = this.sanitizeHtml(decodedContent);
    const hasMaliciousContent = this.isMalicious(decodedContent, sanitizedContent);
    if (hasMaliciousContent) {
      this.log.warn("Blocked malicious content in RemoteContent");
    }
    return /*#__PURE__*/React.createElement("div", null, hasMaliciousContent && /*#__PURE__*/React.createElement(Typography, {
      color: "error",
      variant: "body2"
    }, "Content blocked due to detected security risks."), /*#__PURE__*/React.createElement(Typography, {
      color: color !== null && color !== void 0 ? color : "textPrimary",
      variant: "body2",
      className: `${wrapWhiteSpace ? classes.remoteContentContainer : ""}`,
      style: {
        wordBreak
      }
    }, /*#__PURE__*/React.createElement("span", {
      dangerouslySetInnerHTML: {
        __html: content
      },
      onClickCapture: this.handleAnchorClick,
      id: id
    })));
  }
}
const styles = {
  remoteContentContainer: {
    whiteSpace: "pre-wrap"
  }
};
export default withStyles(styles)(RemoteContent);
RemoteContent.propTypes = {
  content: PropTypes.string,
  id: PropTypes.string,
  color: PropTypes.string,
  onMessageLinkClick: PropTypes.func,
  classes: PropTypes.object.isRequired,
  wrapWhiteSpace: PropTypes.bool,
  allowNewWindow: PropTypes.bool,
  wordBreak: PropTypes.string
};
RemoteContent.defaultProps = {
  onMessageLinkClick: () => {},
  wrapWhiteSpace: true,
  allowNewWindow: false
};